import { Notification } from '../../notification/Notification';

export class NotificationBaseComponent extends Notification {}
